import { styled } from "styled-components";

export const HierarchyWrapper = styled.aside`
  a {
    color: ${(props) => props.theme.colours.primary.black};
    text-decoration: none;
  }
`;
